import { render, staticRenderFns } from "./TaskQuickPeek.vue?vue&type=template&id=53744c21"
import script from "./TaskQuickPeek.vue?vue&type=script&lang=js"
export * from "./TaskQuickPeek.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports